<div class="pad15 withpopupCard card">
    <div class="row">
        <div class="font16 fontbold ml-auto mr-3">
            <span class="font16 fontnormal" translate>lblTotal</span>:&nbsp;{{totalCount}}
            <span class="font16 fontnormal" translate>lblResults</span>
        </div>
    </div>
  </div>
  <div class="scrollbar dwo">
    <div class="card">
        <div class="table-responsive max-h240" infinite-scroll>
            <table class="tablest1 fixed-header">
                <thead>
                    <tr>
                        <th scope="col" translate>lblNo</th>
                        <th scope="col" translate>lblField</th>
                        <th scope="col" translate>lblUpdatedValue</th>
                        <th scope="col" translate>lblPrevValue</th>
                        <th scope="col" translate>lblDate</th>
                        <th scope="col" translate>lblUsers</th>
                        <th scope="col" translate>lblModule</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngIf="customerUpdateHistory?.length > 0; else load_else">
                        <tr *ngFor="let history of customerUpdateHistory; let i=index">
                            <td>{{i+1}}</td>
                            <td>
                                {{getType(history.typeId)}}
                            </td>
                            <td>
                                {{history.updatedValue}}
                            </td>
                            <td>
                                {{history.prevValue}}
                            </td>
                            <td>
                                {{ history.createdDate | date:'short'}}
                            </td>
                            <td>
                                {{history.createdBy}}
                            </td>
                            <td>
                                {{history.applicationName}}
                            </td>
                        </tr>
                    </ng-container>
                    <ng-template #load_else>
                        <tr>
                            <td colspan="8" class="no-record" translate>lblNoRecordsFound</td>
                        </tr>
                    </ng-template>
                </tbody>
            </table>
        </div>
    </div>
</div>
<div class="p-3 bg-light pp-footer-top-brdr">
    <div class="row">
        <div class="col-12 d-flex flex-sm-row flex-column justify-content-end">
            <button type="button" class="add-button btn btn-secondary btn-lg"
                translate>lblCancel</button>
        </div>
    </div>
</div>